module.exports = __webpack_public_path__ + "img/netent.7492a5ee.svg";